import App from './App.vue'
import Vue from 'vue'
import Element from 'element-ui'
import './assets/css/styles.css'
import 'element-ui/lib/theme-chalk/index.css';

import router from "./router";
import store from "./store";

Vue.use(Element)

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})

Element.Dialog.props.closeOnClickModal.default = false;

